import { ContractMailTemplateType } from '@gi/enums/contract-mail-template-type.enum';
import { DateHelper } from '@helpers/date.helper';

export interface ContractEmailContentTemplateJson {
  id: number;
  type: ContractMailTemplateType;
  name: string;
  is_default: boolean;
  archived_at: string;
  subject: string;
  content: string;
}

export class ContractEmailContentTemplate {
  constructor(
    public id?: number,
    public type?: ContractMailTemplateType,
    public name?: string,
    public isDefault?: boolean,
    public archivedAt?: Date,
    public subject?: string,
    public content?: string
  ) {}

  static fromJson(json: ContractEmailContentTemplateJson): ContractEmailContentTemplate {
    return new ContractEmailContentTemplate(
      json.id,
      json.type,
      json.name,
      json.is_default,
      json.archived_at ? DateHelper.fromUtc(json.archived_at) : null,
      json.subject,
      json.content
    );
  }

  static toJson(model: ContractEmailContentTemplate): Omit<ContractEmailContentTemplateJson, 'archived_at'> {
    return {
      id: model.id,
      type: model.type,
      name: model.name,
      is_default: model.isDefault,
      subject: model.subject,
      content: model.content
    };
  }
}
